var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t(_vm.$route.meta.title)))]),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }